module.exports = __webpack_public_path__ + "0918417c8847dc9296253ab60da9fe54.svg";